import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseServiceV2 } from '@servicesv2';
import { ContratoMensalidadeViewModel, FiltroContratosMensalidadesViewModel, GerarMensalidadesPayloadViewModel } from '../../modais/diversos/modal-gerar-mensalidades/models';
import { ConsultaPaginadaViewModel } from '@models';

@Injectable()
export class ContratosServiceV2 extends BaseServiceV2 {

  constructor(http: HttpClient) {
    super('Contratos', http);
  }

  getSequenciaNumero() {
    return this.getAsPromise<number>('GetSequenciaNumero');
  }

  getContratoDuplicado(clienteId: number, contratoId: number) {
    return this.getAsPromise<boolean>(`GetContratoDuplicado/${clienteId}/${contratoId}`);
  }

  getPaginadaModalGerarMensalidades(filtro: FiltroContratosMensalidadesViewModel) {
    return this.postPaginatedAsPromise<FiltroContratosMensalidadesViewModel, ConsultaPaginadaViewModel<ContratoMensalidadeViewModel>>(filtro, 'GetPaginadaModalGerarMensalidades');
  }

  gerarMensalidadesContrato(gerarMensalidades: GerarMensalidadesPayloadViewModel) {
    return this.postAsPromise<GerarMensalidadesPayloadViewModel, any>(gerarMensalidades, 'GerarPedido');
  }

}